export const regions = {
  basel: {id: "basel", name: "Basel"},
  biel: {id: "biel", name: "Biel"}
}



// WEBPACK FOOTER //
// ./src/utils/regions.js